/* eslint-disable @typescript-eslint/no-explicit-any */
import { ButtonGroup, Dropdown } from "react-bootstrap";
import SntLink from "@/components/ReactBootstrap/SntLink";
import SntSmallMenu from "@icons/SntSmallMenu";
import { FeatureKey } from "@/types/generated/FeatureKey";
import { hasFeature } from "@/hooks/useFeatures";
import { SortActions } from "./SortActions";
import { GroupActions } from "./GroupActions";
import { DataActions } from "./DataActions";
import { ConfigActions } from "./ConfigActions";
import { FilterActions } from "./FilterActions";

interface ColumnMenuProps {
  column: any;
  headerGroup: any;
  dataFilter: any;
  rows: any[];
  prepareRow: (row: any) => void;
  toggleSortBy: (columnKey: string, desc: boolean) => void;
  isDisabbledGroup: boolean;
  isDisabledCopyData: boolean;
  isDisabbledAddFilter: boolean;
  onConfigColumn?: () => void;
  onExtraColumnActionClicked?: (action: string, params: any) => void;
  onFilterClicked?: (
    action: string,
    columnKey: string,
    filterKeys: string[],
    cellValue: any[]
  ) => void;
  restrictedFilters?: string[];
  filterVisibleKeys?: string[];
  organisationType?: string;
}

export const ColumnMenu = ({
  column,
  headerGroup,
  dataFilter,
  rows,
  prepareRow,
  toggleSortBy,
  isDisabbledGroup,
  isDisabledCopyData,
  isDisabbledAddFilter,
  onConfigColumn,
  onExtraColumnActionClicked,
  onFilterClicked,
  restrictedFilters,
  filterVisibleKeys,
  organisationType,
}: ColumnMenuProps) => {
  // Don't show menu for immovable columns
  if (column.immovable) return null;

  // Check if we should show the menu at all
  const shouldShowMenu =
    !column.disableSortBy ||
    (hasFeature(FeatureKey.search_aggregate) &&
      !isDisabbledGroup &&
      !column.disabledGroupColumn) ||
    onConfigColumn;

  if (!shouldShowMenu) return null;

  return (
    <Dropdown
      className="hide-arrow table-group"
      style={{ zIndex: 1002 }}
      as={ButtonGroup}
    >
      <Dropdown.Toggle as={SntLink} className="table-group-toggle">
        <SntSmallMenu />
      </Dropdown.Toggle>

      <Dropdown.Menu className="table-group-menu">
        <SortActions column={column} toggleSortBy={toggleSortBy} />

        <GroupActions
          column={column}
          headerGroup={headerGroup}
          dataFilter={dataFilter}
          isDisabbledGroup={isDisabbledGroup}
        />

        <DataActions
          column={column}
          rows={rows}
          prepareRow={prepareRow}
          isDisabledCopyData={isDisabledCopyData}
          onExtraColumnActionClicked={onExtraColumnActionClicked}
          organisationType={organisationType}
        />

        <ConfigActions
          column={column}
          dataFilter={dataFilter}
          onConfigColumn={onConfigColumn}
        />

        <FilterActions
          column={column}
          isDisabbledAddFilter={isDisabbledAddFilter}
          restrictedFilters={restrictedFilters}
          filterVisibleKeys={filterVisibleKeys}
          onFilterClicked={onFilterClicked}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
